import React, { ComponentProps } from 'react';
import { asView } from '../../../_lib/ViewFetcher';
import { AdditionalPrivilegeItem } from '../PrivilegeConfig.types';
import { AdditionalPrivilegeTree } from '../partials/AdditionalPrivilegeTree';

type AdditionalPrivilegeConfigDefaultViewProps = {
  privileges: AdditionalPrivilegeItem[];
};

function AdditionalPrivilegeConfigDefault({ privileges }: AdditionalPrivilegeConfigDefaultViewProps) {
  return <AdditionalPrivilegeTree privilegeItems={privileges} parentAdditionalPrivilegeLabels={[]} />;
}

export const AdditionalPrivilegeConfigDefaultView = asView(AdditionalPrivilegeConfigDefault);
export type AdditionalPrivilegeConfigDefaultView = ComponentProps<typeof AdditionalPrivilegeConfigDefaultView>;
